import { render, staticRenderFns } from "./issureRecord.vue?vue&type=template&id=308469ba&scoped=true"
import script from "./issureRecord.vue?vue&type=script&lang=js"
export * from "./issureRecord.vue?vue&type=script&lang=js"
import style0 from "./issureRecord.vue?vue&type=style&index=0&id=308469ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308469ba",
  null
  
)

export default component.exports